import { composeWidgetDocument } from "../../../widgets/composeWidgetDocument";

/**
 * Slugify a string to a safe filename segment (no spaces, lowercase, hyphens).
 * Mirrors the slugify used in sarSpecToCsv for consistency.
 */
export function slugify(s) {
  return String(s ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "widget";
}

/**
 * Compose a standalone HTML document from a widget spec (raw HTML fragment)
 * and return it along with a suggested download filename.
 *
 * @param {string} spec  — the raw HTML fragment (widget body)
 * @param {string} title — widget title used for the filename
 * @returns {{ html: string, filename: string }}
 */
export function widgetSpecToHtml(spec, title) {
  const html = composeWidgetDocument(spec, {});
  const filename = `${slugify(title || "widget")}.html`;
  return { html, filename };
}
